import React from 'react'
import { useStyles } from './styles'
import Paper from '@material-ui/core/Paper'
import { ValueScale, ArgumentScale } from '@devexpress/dx-react-chart'
import { scaleBand } from '@devexpress/dx-chart-core'
import { ArgumentAxis, ValueAxis, Chart, BarSeries, Title } from '@devexpress/dx-react-chart-material-ui'
import TitleText from './components/TitleText'
import ValueAxisLegend from './components/ValueAxisLegend'
import ArgumentAxisLegend from './components/ArgumentAxisLegend'
import { PACE_GRAPH_ROOT_CONTAINER_ID } from '../../../../utils/graphUtils'
import Bar from './components/Bar'
import Export from './components/Export'

const PaceGraph = ({ data: { learners }, type, filterName }) => {
  const classes = useStyles()
  const pace = learners.progress.pace
  let chartData = [
    {
      type: 'Ahead',
      value: pace ? pace.ahead : 0
    },
    {
      type: 'On Track',
      value: pace ? pace.onTrack : 0
    },
    {
      type: 'Behind',
      value: pace ? pace.behind : 0
    }
  ]

  return (
    <Paper className={classes.chartBackground} id={PACE_GRAPH_ROOT_CONTAINER_ID}>
      <Chart data={chartData} className={classes.chart}>
        <ArgumentAxis
          showTicks={false}
          indentFromAxis={16}
          labelComponent={props => {
            return (
              <ArgumentAxis.Label
                {...props}
                y={props.y}
                style={{
                  fill: '#000000',
                  fontFamily: 'National',
                  fontSize: '13px'
                }}
                text={props.text}
              />
            )
          }}
        />
        <ArgumentScale factory={scaleBand} />
        <ValueScale modifyDomain={([min, max]) => [min, max ? max * 1.25 : 1]} />
        <Title text='Pace' textComponent={TitleText} />
        <ValueAxis showGrid={false} showLine={true} tickFormat={() => tick => (Number.isInteger(tick) ? tick : null)} />
        <BarSeries valueField='value' argumentField='type' barWidth={0.7} pointComponent={Bar} chartData={chartData} />
        <ValueAxisLegend />
        <ArgumentAxisLegend />
        <Export />
      </Chart>
    </Paper>
  )
}

export default PaceGraph
